<p-dialog
  #fastModeloTransp
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar modelo de veículo</span>
      <i class="mdi mdi-car-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row p-2">
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <input
          id="inputtext-nome"
          class="input-filters"
          pInputText
          [formControl]="form.get('nome')"
          (blur)="actionFnCheckEntityExist(form.get('nome'))"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-nome">Nome *</label>
      </span>
      <small class="p-error" *ngIf="form.get('nome').hasError('required')">
        {{ displayMessage.nome.required }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('maxlength')">
        {{ displayMessage.nome.maxlength }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('isEmptyValue')">
        {{ displayMessage.nome.isEmptyValue }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('duplicate')">
        {{ displayMessage.nome.duplicate }}
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <fast-autocomplete
        #input
        class="width-100"
        id="field-marca"
        placeholder="Marca"
        required
        [autoFirst]="false"
        displayField="nome"
        [value_order]="'nome'"
        [pageValue]="'0'"
        [pageSizeValue]="'10'"
        [control]="form.get('marca')"
        (clearSelection)="form.get('marca').reset()"
        [entityService]="marcaService"
        [actionState]="checkDisponibilidade('POST', '', '/marcas')"
        [insertType]="'marca'"
        [initDataWithEmpty]="true"
        [messages]="{
          required: 'Selecione uma marca de veículo.',
          typeIs: 'Valor inválido',
          isEmptyValue: 'Inválido: remova os espaços em branco!'
        }"
      ></fast-autocomplete>
    </div>
    <div class="col-md-4 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>KM da caixa</mat-label>
        <input
          matInput
          (keydown)="validateNumbers($event)"
          type="text"
          [formControl]="form.get('km_caixa')"
          style="text-align: right;"
        />
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('km_caixa').hasError('required')">
        {{ displayMessage.km_caixa.required }}
      </small>
      <small class="p-error" *ngIf="form.get('km_caixa').hasError('max_value')">
        {{ displayMessage.km_caixa.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_caixa').hasError('before_split')"
      >
        {{ displayMessage.km_caixa.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_caixa').hasError('after_split')"
      >
        {{ displayMessage.km_caixa.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_caixa').hasError('errorComma')"
      >
        {{ displayMessage.km_caixa.errorComma }}
      </small>
      <small class="p-error" *ngIf="form.get('km_caixa').hasError('errorDots')">
        {{ displayMessage.km_caixa.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_caixa').hasError('notNumbers')"
      >
        {{ displayMessage.km_caixa.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_caixa').hasError('invalidNumber')"
      >
        {{ displayMessage.km_caixa.invalidNumber }}
      </small>
    </div>
    <div class="col-md-4 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>KM do motor</mat-label>
        <input
          matInput
          (keydown)="validateNumbers($event)"
          type="text"
          [formControl]="form.get('km_motor')"
          style="text-align: right;"
        />
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('km_motor').hasError('required')">
        {{ displayMessage.km_motor.required }}
      </small>
      <small class="p-error" *ngIf="form.get('km_motor').hasError('max_value')">
        {{ displayMessage.km_motor.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_motor').hasError('before_split')"
      >
        {{ displayMessage.km_motor.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_motor').hasError('after_split')"
      >
        {{ displayMessage.km_motor.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_motor').hasError('errorComma')"
      >
        {{ displayMessage.km_motor.errorComma }}
      </small>
      <small class="p-error" *ngIf="form.get('km_motor').hasError('errorDots')">
        {{ displayMessage.km_motor.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_motor').hasError('notNumbers')"
      >
        {{ displayMessage.km_motor.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_motor').hasError('invalidNumber')"
      >
        {{ displayMessage.km_motor.invalidNumber }}
      </small>
    </div>
    <div class="col-md-4 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>KM diferencial</mat-label>
        <input
          matInput
          (keydown)="validateNumbers($event)"
          type="text"
          [formControl]="form.get('km_diferencial')"
          style="text-align: right;"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('km_diferencial').hasError('required')"
      >
        {{ displayMessage.km_diferencial.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_diferencial').hasError('max_value')"
      >
        {{ displayMessage.km_diferencial.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_diferencial').hasError('before_split')"
      >
        {{ displayMessage.km_diferencial.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_diferencial').hasError('after_split')"
      >
        {{ displayMessage.km_diferencial.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_diferencial').hasError('errorComma')"
      >
        {{ displayMessage.km_diferencial.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_diferencial').hasError('errorDots')"
      >
        {{ displayMessage.km_diferencial.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_diferencial').hasError('notNumbers')"
      >
        {{ displayMessage.km_diferencial.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('km_diferencial').hasError('invalidNumber')"
      >
        {{ displayMessage.km_diferencial.invalidNumber }}
      </small>
    </div>
    <div class="col-md-6 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Quantidade de pneus</mat-label>
        <input
          matInput
          (keydown)="validateOnlyNumbers($event)"
          type="text"
          [formControl]="form.get('qtd_pneus')"
          style="text-align: right;"
        />
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('qtd_pneus').hasError('required')">
        {{ displayMessage.qtd_pneus.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_pneus').hasError('max_value')"
      >
        {{ displayMessage.qtd_pneus.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_pneus').hasError('before_split')"
      >
        {{ displayMessage.qtd_pneus.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_pneus').hasError('after_split')"
      >
        {{ displayMessage.qtd_pneus.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_pneus').hasError('errorComma')"
      >
        {{ displayMessage.qtd_pneus.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_pneus').hasError('errorDots')"
      >
        {{ displayMessage.qtd_pneus.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_pneus').hasError('notNumbers')"
      >
        {{ displayMessage.qtd_pneus.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_pneus').hasError('invalidNumber')"
      >
        {{ displayMessage.qtd_pneus.invalidNumber }}
      </small>
    </div>
    <div class="col-md-6 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Quantidade de eixos</mat-label>
        <input
          matInput
          (keydown)="validateOnlyNumbers($event)"
          type="text"
          [formControl]="form.get('qtd_eixos')"
          style="text-align: right;"
        />
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('qtd_eixos').hasError('required')">
        {{ displayMessage.qtd_eixos.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_eixos').hasError('max_value')"
      >
        {{ displayMessage.qtd_eixos.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_eixos').hasError('before_split')"
      >
        {{ displayMessage.qtd_eixos.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_eixos').hasError('after_split')"
      >
        {{ displayMessage.qtd_eixos.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_eixos').hasError('errorComma')"
      >
        {{ displayMessage.qtd_eixos.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_eixos').hasError('errorDots')"
      >
        {{ displayMessage.qtd_eixos.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_eixos').hasError('notNumbers')"
      >
        {{ displayMessage.qtd_eixos.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_eixos').hasError('invalidNumber')"
      >
        {{ displayMessage.qtd_eixos.invalidNumber }}
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        [disabled]="loading"
        (click)="dialogRef.close()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
